import { useEffect, ReactElement } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import MindDetailsOverlay from '~/curriculum/components/MindDetailsOverlay'
import { selectShowMindDetailsOverlay, setShowMindDetailsOverlayActionCreator } from '~/redux/slices/mind-overlay'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

interface mindButtonProps {
  className?: string
  imageClassName?: string
  tosterMessage?: string
  mindUpdated?: boolean
  setMindUpdated?: (updated: boolean) => void
  isFromProgress?: boolean
  onClickTrackingEvent?: () => void
}

export default function MindButton({
  className,
  imageClassName,
  tosterMessage,
  mindUpdated = false,
  setMindUpdated,
  isFromProgress = false,
  onClickTrackingEvent,
}: mindButtonProps): ReactElement {
  const dispatch = useAppDispatch()
  const showMindDetailsOverlay = useAppSelector(selectShowMindDetailsOverlay)
  const mindButtonOnClick = (): void => {
    if (onClickTrackingEvent) {
      onClickTrackingEvent()
    }
    dispatch(setShowMindDetailsOverlayActionCreator(true))
  }

  useEffect(() => {
    if (mindUpdated) {
      setTimeout(() => {
        if (setMindUpdated) setMindUpdated(false)
      }, 1500)
    }
  }, [mindUpdated, setMindUpdated])

  let mindButtonComponent: React.ReactElement

  if (isFromProgress) {
    mindButtonComponent = (
      <button
        className="md:drop-shadow-mind-glow pt-2 ml-2 md:ml-4 w-16 md:w-18 flex-shrink-0"
        id="mind-intro-target"
        onClick={() => dispatch(setShowMindDetailsOverlayActionCreator(true))}
      >
        <ResponsiveImage height={35} imageClassName="w-full -rotate-30" srcKey="landing/mind-ai-v2.png" width={35} />
      </button>
    )
  } else {
    mindButtonComponent = (
      <div className={`flex justify-end items-start ${className}`}>
        <div className="flex items-center justify-center ">
          <div
            className={`h-7 rounded-3xl bg-white pl-1 pr-3 items-center gap-2 flex relative overflow-hidden transition-all duration-1000 ${
              mindUpdated ? 'max-w-92.5 opacity-100' : 'max-w-8 opacity-0'
            }`}
          >
            <div className="absolute text-center text-white items-center justify-center h-6 w-6 rounded-full bg-purple left-1 top-1/2 -translate-y-1/2 flex">
              <p>i</p>
            </div>
            <p className="text-xs font-semibold ml-8 whitespace-nowrap">{tosterMessage}</p>
          </div>

          <button className="cursor-pointer w-14 md:w-16 -rotate-30" onClick={mindButtonOnClick}>
            <ResponsiveImage
              height={45}
              imageClassName={imageClassName ? imageClassName : 'w-full'}
              srcKey="landing/mind-ai-v2.png"
              width={45}
            />
          </button>
        </div>
      </div>
    )
  }

  return (
    <>
      {!showMindDetailsOverlay && mindButtonComponent}
      {showMindDetailsOverlay && (
        <MindDetailsOverlay onDismiss={() => dispatch(setShowMindDetailsOverlayActionCreator(false))} />
      )}
    </>
  )
}
